exports.PAGE_TRANSITION_TIME_MS = 1500; //Update class page-fade-out if value changed for seamless page transition
exports.SLIDE_PAGE_TRANSITION_TIME_MS = 1000;

exports.PAGE_NAMES = {
  TEAMLIST: "teamlist",
  CAREER: "career",
};

exports.MOBILE_SCREEN_WIDTH = 510;
exports.MOBILE_SCREEN_HEIGHT = 950;
exports.DESKTOP_MENU_HEIGHT = "100px";
exports.MOBILE_MENU_HEIGHT = 50;

exports.MIN_CHARACTER_LENGTH_FORM = 40;

exports.FADEINUP_DELAY_BY_INDEX = {
  0: "delay-1",
  1: "delay-2",
  2: "delay-3",
  3: "delay-4",
  4: "delay-5",
  5: "delay-6",
  6: "delay-7",
  7: "delay-8",
  8: "delay-9",
  9: "delay-10",
  10: "delay-11",
  11: "delay-12",
  12: "delay-13",
  13: "delay-14",
  14: "delay-15",
};
